import { postAuthenticated } from '../../../../../../services/RestTemplate';

const createUserUrl = '/users';

export function createUser(userToCreate) {
    return postAuthenticated(createUserUrl, userToCreate);
}
